import { Value } from "lib/build/schema";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useQueryParam } from "src/common/hooks/useQueryParam";
import { modMessages, orgMessages } from "src/messages/generic";

export function useInitialValue(): Value {
	const formatMessage = useFormatMessageMap();
	return {
		title: useQueryParam("title"),
		firstName: useQueryParam("firstName"),
		lastName: useQueryParam("lastName"),
		email: useQueryParam("email"),
		organization: formatMessage(
			orgMessages,
			useQueryParam("organization") || ""
		),
		module: formatMessage(modMessages, useQueryParam("module") || ""),
		role: useQueryParam("role"),
		phoneNumber: useQueryParam("phoneNumber"),
		occupation: useQueryParam("occupation"),
		stampNumber: useQueryParam("stampNumber"),
		defaultLanguage: useQueryParam("defaultLanguage")
	};
}
